"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityResponseToJSON = exports.OpportunityResponseFromJSONTyped = exports.OpportunityResponseFromJSON = exports.instanceOfOpportunityResponse = void 0;
var runtime_1 = require("../runtime");
var Opportunity_1 = require("./Opportunity");
/**
 * Check if a given object implements the OpportunityResponse interface.
 */
function instanceOfOpportunityResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfOpportunityResponse = instanceOfOpportunityResponse;
function OpportunityResponseFromJSON(json) {
    return OpportunityResponseFromJSONTyped(json, false);
}
exports.OpportunityResponseFromJSON = OpportunityResponseFromJSON;
function OpportunityResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'opportunities': !(0, runtime_1.exists)(json, 'opportunities') ? undefined : (json['opportunities'].map(Opportunity_1.OpportunityFromJSON)),
    };
}
exports.OpportunityResponseFromJSONTyped = OpportunityResponseFromJSONTyped;
function OpportunityResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'opportunities': value.opportunities === undefined ? undefined : (value.opportunities.map(Opportunity_1.OpportunityToJSON)),
    };
}
exports.OpportunityResponseToJSON = OpportunityResponseToJSON;
